<canvas #canvas [attr.height]="height"></canvas>

<ion-list *ngIf="chart">
    <ion-item *ngFor="let data of legendItems">
        <ion-icon name="fas-square" slot="start" [style.color]="data.fillStyle" aria-hidden="true" />
        <ion-label>{{data.text}}</ion-label>
    </ion-item>
</ion-list>
